import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { FormattedMessage } from 'react-intl'
import { atLeastTwoActivities } from '../../../utils/messages'

export default class NoActivities extends Component {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  // Don't love this, but because NoActivies / Activities Menu Label aren't part of the
  // activity component nor activity menu component, need to rig up this menu highlighting separately
  componentDidMount() {
    document.getElementById('activitiesMenuItem').classList += 'active'
  }

  componentWillUnmount() {
    document.getElementById('activitiesMenuItem').classList = ''
  }

  render() {
    return (
      <div className="no-activities">
        {this.props.allowEdit && (
          <div>
            <div className="add-activity" onClick={this.onClickBound}>
              <FormattedMessage
                id={'Quest.NoActivities.AddFirstActivity'}
                defaultMessage={'add the first activity'}
              />
            </div>
            <p>{atLeastTwoActivities}</p>
          </div>
        )}
        {!this.props.allowEdit && <p>{atLeastTwoActivities}</p>}
      </div>
    )
  }

  onClick() {
    this.props.dispatch(push(`/quest/${this.props.quest.id}/activities/add`))
  }
}

NoActivities.propTypes = {
  dispatch: PropTypes.func,
  quest: PropTypes.object,
  allowEdit: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/quest/section/NoActivities.js